import { NextPage } from 'next'
import Layout from '../../components/Layout'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { useRouter } from 'next/router'
import { PLAN_QUERY } from '../../gql/queries'
import UseproofCode from '../../components/UseproofCode'
import TestimonialsBlock from './components/TestimonialBlock'
import CheckoutForm from './components/CheckoutForm'
import { withGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { Plan } from '../../__generated__/graphql'
import { useQuery } from '@apollo/client'

const CheckoutFormWithCaptcha = withGoogleReCaptcha(CheckoutForm)

const SignUpPage: NextPage = () => {
  const stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_API_KEY)
  const router = useRouter()
  const planParameter = router.query.plan || 'free'
  const overrideInvitation = router.query.overrideInvitation === 'true'
  const emailFromQuery = router.query.email as string | undefined

  const { data } = useQuery(PLAN_QUERY, {
    variables: { planName: planParameter }
  })

  const plan = data?.plan

  return (
    <>
      <img
        src="https://worshiponline.com/split-test-for-elementor/v1/tests/1/track-conversion/"
        alt=""
      />
      <UseproofCode />
      <Elements stripe={stripePromise}>
        <Layout hideHeader>
          {plan && (
            <CheckoutFormWithCaptcha
              plan={plan as Plan}
              email={emailFromQuery}
              overrideInvitation={overrideInvitation}
            />
          )}
          <TestimonialsBlock />
        </Layout>
      </Elements>
    </>
  )
}

export default SignUpPage
